var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayDuotone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "play-duotone_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z",
    fill: "currentColor",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.003a1 1 0 011.513-.858l4.997 2.989a1.01 1.01 0 010 1.733l-4.997 2.988A1 1 0 019 14.997V9.003z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMjIgMTJDMjIgMTcuNTIyOCAxNy41MjI4IDIyIDEyIDIyQzYuNDc3MTUgMjIgMiAxNy41MjI4IDIgMTJDMiA2LjQ3NzE1IDYuNDc3MTUgMiAxMiAyQzE3LjUyMjggMiAyMiA2LjQ3NzE1IDIyIDEyWiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuMjUiLz48cGF0aCBkPSJNOSA5LjAwMzQ5QzkgOC4yMjY4NiA5Ljg0NjY4IDcuNzQ2NjUgMTAuNTEzMiA4LjE0NTI0TDE1LjUxMDQgMTEuMTMzNUMxNi4xNjU5IDExLjUyNTUgMTYuMTY1OSAxMi40NzUyIDE1LjUxMDQgMTIuODY3MkwxMC41MTMyIDE1Ljg1NTNDOS44NDY2NiAxNi4yNTM4IDkgMTUuNzczNiA5IDE0Ljk5N1Y5LjAwMzQ5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { SvgPlayDuotone as ReactComponent };